import {REST_METHODS} from '@/src/app/constants/api';
import {SEARCH_FILTERS} from '@/src/app/constants/search';
import {getAuthorizationToken} from '@/src/app/utils/authorizationToken';
import authorizedFetch from '@/src/app/utils/authorizedFetch';
import unauthorizedFetch from '@/src/app/utils/unauthorizedFetch';

const MAX_CLINICS_COUNT = 10;

interface fetchClinicsForUnitedTabProps {
  searchQuery: string;
  locale: string;
}

const fetchClinicsForUnitedTab = ({
  searchQuery,
  locale,
}: fetchClinicsForUnitedTabProps) => {
  const method = getAuthorizationToken() ? authorizedFetch : unauthorizedFetch;

  // @ts-ignore
  return method({
    method: REST_METHODS.GET,
    path: `/api/v1/job_portal/clinics_search`,
    queryParams: [
      {
        name: SEARCH_FILTERS.LANGUAGE,
        value: locale,
      },
      {
        name: SEARCH_FILTERS.SEARCH,
        value: searchQuery,
      },
      {
        name: SEARCH_FILTERS.PER_PAGE,
        value: MAX_CLINICS_COUNT,
      },
    ],
  });
};

export default fetchClinicsForUnitedTab;
